var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "customs-svg-icon",
    class: _vm.customClass,
    style: _vm.customStyle,
    attrs: {
      "alt": _vm.alt,
      "title": _vm.title,
      "width": _vm.width,
      "height": _vm.height,
      "role": _vm.role
    },
    domProps: {
      "innerHTML": _vm._s(_vm.svgContent)
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }